import { FETCH_ERROR } from "@boark/shared/consts/fetch-error";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  getFastumTicket,
  getFastumTickets,
  importFastumTickets,
} from "../services/fastum";

export function useGetFastumTickets({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ["fastum-tickets"],
    queryFn: () => getFastumTickets(),
    enabled,
    staleTime: 1000 * 60,
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}

export function useGetFastumTicket(id: string) {
  return useQuery({
    queryKey: ["fastum-ticket", id],
    queryFn: () => getFastumTicket(id),
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}

export function useImportFastumTickets() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => importFastumTickets(),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["fastum-tickets"] });
    },
  });
}
